import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router';
import Header from './Header';
import Contents from './Contents';
import Coupon from './Coupon';
import Preview from './Preview';
import { setData } from '../../../features/recurringMessageSlice';
import isSun from '../../../assets/images/svg/ic-sun.svg';
import { color } from '../../../app/theme';
import { LoginResultAwardMethod, GameType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      position: 'relative',
    },
    setting: {
      width: 'calc(100% - 368px + 44px)',
    },
    sun: {
      marginTop: 24,
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$15,
      width: 80,
      borderRadius: '20px',
      justifyContent: 'center',
      padding: '2px 0',
      marginBottom: 6,
    },
    hint: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
      marginBottom: 44,
    },
  },
  {
    name: 'Step2Container',
  },
);

const Step2Container = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { orgId } = useParams();
  const { data, isSaved, isActive } = useSelector(
    store => store.recurringMessage,
  );
  const { contents, award } = data || {};

  const handleContentsChange = value => {
    dispatch(
      setData({
        contents: value,
      }),
    );
  };

  const handleMethodChange = value => {
    if (value === LoginResultAwardMethod.GAME) {
      dispatch(
        setData({
          award: {
            ...award,
            method: value,
            gameType: GameType.ROULETTE,
            value: undefined,
          },
        }),
      );
    } else {
      dispatch(
        setData({
          award: {
            ...award,
            method: value,
            gameType: undefined,
            value: undefined,
          },
        }),
      );
    }
  };

  const handleTypeChange = value => {
    dispatch(
      setData({
        award: {
          ...award,
          gameType: value,
        },
      }),
    );
  };

  const handleEnableChange = value => {
    dispatch(
      setData({
        award: {
          ...award,
          enabled: value,
        },
      }),
    );
  };

  const handleCouponSetIdChange = value => {
    dispatch(
      setData({
        award: {
          ...award,
          value,
        },
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <Contents
          orgId={orgId}
          contents={contents}
          disabled={isActive}
          onChange={handleContentsChange}
          isSaved={isSaved}
        />
        <Coupon
          data={award}
          isSaved={isSaved}
          onMethodChange={handleMethodChange}
          onTypeChange={handleTypeChange}
          onCouponSetIdChange={handleCouponSetIdChange}
          onEnable={handleEnableChange}
        />
        <div className={classes.sun}>
          <img src={isSun} alt="minus" />
          {t('tip')}
        </div>
        <div className={classes.hint}>{t('recurringMessage:hint')}</div>
      </div>
      <Preview elements={contents?.elements || []} />
    </div>
  );
};

export default Step2Container;
